// config
import constants from 'config/constants'

/** SEF role checking
 * @param {Object} roleData - role data from user
 * @returns {Object} - object with booleans for each role
 */
function checkRoles({ roleData }) {
  const isWorkspaceAdmin = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.SEF_WORKSPACE &&
      r.role_type === constants.ROLES.SEF_WORKSPACE_ADMIN
    )
  })

  const isWorkspaceFinanceAdmin = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.SEF_WORKSPACE &&
      r.role_type === constants.ROLES.SEF_WORKSPACE_FINANCE_ADMIN
    )
  })

  const isWorkspaceOperationsAdmin = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.SEF_WORKSPACE &&
      r.role_type === constants.ROLES.SEF_WORKSPACE_OPERATIONS_ADMIN
    )
  })

  const isWorkspaceOwner = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.SEF_WORKSPACE &&
      r.role_type === constants.ROLES.SEF_WORKSPACE_OWNER
    )
  })

  const isWorkspaceProjectAdmin = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.SEF_WORKSPACE_PROJECT &&
      r.role_type === constants.ROLES.SEF_WORKSPACE_PROJECT_ADMIN
    )
  })

  const isWorkspaceProcurementAdmin = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.SEF_WORKSPACE &&
      r.role_type === constants.ROLES.SEF_WORKSPACE_PROCUREMENT_ADMIN
    )
  })

  const isWorkspaceSigningAdmin = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.SEF_WORKSPACE &&
      r.role_type === constants.ROLES.SEF_WORKSPACE_SIGNING_ADMIN
    )
  })

  const isWorkspaceTimekeeperAdmin = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.SEF_WORKSPACE &&
      r.role_type === constants.ROLES.SEF_WORKSPACE_TIMEKEEPER_ADMIN
    )
  })

  const isPartnerAdmin = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.ORG && r.role_type === constants.ROLES.SEF_PARTNER_ADMIN
    )
  })

  const isPartnerSigningAdmin = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.ORG &&
      r.role_type === constants.ROLES.SEF_PARTNER_SIGNING_ADMIN
    )
  })

  const isPartnerDistrictOutputsAdmin = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.SEF_PARTNER_DISTRICT &&
      r.role_type === constants.ROLES.SEF_PARTNER_DISTRICT_OUTPUTS_ADMIN
    )
  })

  const isWorksiteOutputsAdmin = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.SEF_WORKSITE &&
      r.role_type === constants.ROLES.SEF_WORKSITE_OUTPUTS_ADMIN
    )
  })

  const isPlatformAdmin = roleData.some(r => {
    return (
      r.roleable === constants.ROLEABLES.SEF_PLATFORM &&
      r.role_type === constants.ROLES.SEF_PLATFORM_ADMIN
    )
  })

  const isPartnerDistrictPeopleAdmin = roleData.some(r => {
    return r.role_type === constants.ROLES.SEF_PARTNER_DISTRICT_PEOPLE_ADMIN
  })

  const isPartnerTrainingAdmin = roleData.some(r => {
    return r.role_type === constants.ROLES.SEF_PARTNER_TRAINING_ADMIN
  })

  const isPartnerTimekeeperAdmin = roleData.some(r => {
    return r.role_type === constants.ROLES.SEF_PARTNER_TIMEKEEPER_ADMIN
  })

  const isWorksitePeopleAdmin = roleData.some(r => {
    return r.role_type === constants.ROLES.SEF_WORKSITE_PEOPLE_ADMIN
  })

  const isWorksiteDataCollector = roleData.some(r => {
    return r.role_type === constants.ROLES.SEF_WORKSITE_DATA_COLLECTOR
  })

  const isWorksiteDataStakeholder = roleData.some(r => {
    return r.role_type === constants.ROLES.SEF_WORKSITE_DATA_STAKEHOLDER
  })

  const isSefMember = roleData.some(r => {
    return r.role_type === constants.ROLES.SEF_ORG_MEMBER
  })

  const isPayrollReviewAdmin = roleData.some(r => {
    return [constants.ROLES.SEF_PAYROLL_REVIEW_ADMIN].includes(r.role_type)
  })

  const isGodAdmin = roleData.some(r => r.role_type === constants.ROLES.GOD_MODE)

  const isWorksiteOrDistrictAdmin =
    isWorksiteOutputsAdmin ||
    isWorksitePeopleAdmin ||
    isPartnerDistrictOutputsAdmin ||
    isPartnerDistrictPeopleAdmin

  const isPeopleAdmin = isWorksitePeopleAdmin || isPartnerDistrictPeopleAdmin

  return {
    isGodAdmin,
    isPartnerAdmin,
    isPartnerDistrictOutputsAdmin,
    isPartnerDistrictPeopleAdmin,
    isPartnerSigningAdmin,
    isPartnerTimekeeperAdmin,
    isPartnerTrainingAdmin,
    isPayrollReviewAdmin,
    isPlatformAdmin,
    isSefMember,
    isPeopleAdmin,
    isWorksiteDataCollector,
    isWorksiteDataStakeholder,
    isWorksitePeopleAdmin,
    isWorksiteOutputsAdmin,
    isWorksiteOrDistrictAdmin,
    isWorkspaceAdmin,
    isWorkspaceFinanceAdmin,
    isWorkspaceOperationsAdmin,
    isWorkspaceOwner,
    isWorkspaceProcurementAdmin,
    isWorkspaceProjectAdmin,
    isWorkspaceSigningAdmin,
    isWorkspaceTimekeeperAdmin
  }
}

export default checkRoles
